import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const iv = {
    jpath: ['spectra', 'iv'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default iv;
//# sourceMappingURL=iv.js.map